import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

export default function DetailsImageToggle({ textOnlyMode, onToggle }) {

    return (
        <FormControlLabel control={<Switch checked={!textOnlyMode} onChange={() => {
            onToggle(!textOnlyMode);
        }} />} label="Thumbnails" />
    );
}
